import {
	Currency,
	type Currency$options,
	DistanceSystem,
	type DistanceSystem$options,
	ItineraryConstraint,
	type ItineraryConstraint$options,
	ItineraryTrafficMode,
	type ItineraryTrafficMode$options,
	ItineraryTravelMode,
	type ItineraryTravelMode$options,
} from '$houdini';

export const travelModesList: ItineraryTravelMode$options[] = [
	ItineraryTravelMode.CAR,
	ItineraryTravelMode.MOTORCYCLE,
	ItineraryTravelMode.BIKE,
	ItineraryTravelMode.WALK,
];

export const tripConstraintsList: ItineraryConstraint$options[] = [
	ItineraryConstraint.NONE,
	ItineraryConstraint.NO_TOLL,
	ItineraryConstraint.NO_MOTORWAY,
	ItineraryConstraint.NO_LOW_EMISSION_ZONE,
	ItineraryConstraint.NO_FERRY,
	ItineraryConstraint.NO_VIGNETTE,
	ItineraryConstraint.NO_BORDER_CROSSING,
];

export const itineraryTrafficMap: Record<string, ItineraryTrafficMode$options> = {
	ALL: ItineraryTrafficMode.ALL,
	CLOSINGS: ItineraryTrafficMode.CLOSINGS,
	NONE: ItineraryTrafficMode.NONE,
};

export const distanceSystemsList: DistanceSystem$options[] = [
	DistanceSystem.METRIC,
	DistanceSystem.IMPERIAL,
];

export const currenciesList: Currency$options[] = [
	Currency.eur,
	Currency.usd,
	Currency.gbp,
	Currency.jpy,
	Currency.chf,
	Currency.czk,
	Currency.dkk,
	Currency.hrk,
	Currency.huf,
	Currency.nok,
	Currency.pln,
	Currency.sek,
	Currency.uah,
];
